import React from 'react';
import { createUseStyles } from 'react-jss';
import cx from 'classnames';
import { Theme } from '_lib/theme';

const baseStyle = (theme: Theme) => ({
  margin: 0,
  marginBottom: (props: Props) => props.margin || 0,
  fontFamily: theme.typography.fontFamily,
});

export type Props = {
  margin?: number | string;
  bold?: boolean;
  color?: string;
};

function createBaseElement<T extends Function>(
  elementType: string,
  useStyles: T
) {
  return ({
    children,
    ...props
  }: { children: React.ReactNode; href?: string } & Props) => {
    const classes = useStyles(props);

    return React.createElement(
      elementType,
      {
        ...props,
        className: cx(classes.base, classes.additional),
      },
      children
    );
  };
}

const Base = (
  elementType: string,
  additionalStyle: (theme: Theme) => object
) => {
  const useStyles = createUseStyles((theme: Theme) => ({
    base: baseStyle(theme),
    additional: additionalStyle ? additionalStyle(theme) : {},
  }));

  return createBaseElement(elementType, useStyles);
};

export default Base;
